var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { NotificationsService } from 'packages/notifications/NotificationsService';
import Icon from 'common/UIToolKit/Icon.vue';
var _interval;
var NotificationsBadge = /** @class */ (function (_super) {
    __extends(NotificationsBadge, _super);
    function NotificationsBadge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationsService = new NotificationsService();
        return _this;
    }
    Object.defineProperty(NotificationsBadge.prototype, "totalUnread", {
        get: function () {
            var _a;
            return this.notificationsService.latestUnreadNotifications.pagination.total
                || ((_a = this.notificationsService.latestUnreadNotifications.items) === null || _a === void 0 ? void 0 : _a.length)
                || 0;
        },
        enumerable: false,
        configurable: true
    });
    NotificationsBadge.prototype.mounted = function () {
        var _this = this;
        this.notificationsService.getLatestUnread();
        _interval = window.setInterval(function () {
            if (document.visibilityState === 'visible') {
                _this.notificationsService.getLatestUnread();
            }
        }, this.updateTime * 1000);
    };
    NotificationsBadge.prototype.beforeDestroy = function () {
        clearInterval(_interval);
    };
    __decorate([
        Prop({ default: 60 }),
        __metadata("design:type", Number)
    ], NotificationsBadge.prototype, "updateTime", void 0);
    __decorate([
        Prop({ default: 99 }),
        __metadata("design:type", Number)
    ], NotificationsBadge.prototype, "maxValue", void 0);
    NotificationsBadge = __decorate([
        Component({
            components: {
                Icon: Icon,
            },
        })
    ], NotificationsBadge);
    return NotificationsBadge;
}(Vue));
export default NotificationsBadge;
